import React, { useState, useEffect, useMemo } from "react"
import { Link } from "react-router-dom"

import Modal from "@mui/material/Modal"
import Box from "@mui/material/Box"

import { listenToTdMouseover } from "../../utils/table-animation.js"
import "../Table.sass"
import "./Incident.sass"

import { floatToTimeString } from "../../utils/time-string-float.js"
import { formatToClientTimezone } from "../../utils/format-date-timezone.js"

const TasksTable = ({ data, error }) => {
  const [focusedTask, setFocusedTask] = useState({})

  const [openTaskModal, setOpen] = useState(false)
  const handleOpenTaskModal = (item) => {
    setOpen(true)
    setFocusedTask(item)
  }
  const handleCloseTaskModal = () => setOpen(false)

  useEffect(() => {
    listenToTdMouseover()
  }, [data])

  return (
    <>
      <Modal
        open={openTaskModal}
        onClose={handleCloseTaskModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="box-modal form-wrapper">
          <form>
            {/* Subject */}
            <p>
              <span className="font text-3">
                <strong>Assunto:</strong>
              </span>
              <div className="task-value">
                <span className="font text-2">{focusedTask["subject"]}</span>
              </div>
            </p>

            {/* Description */}
            <p>
              <span className="font text-3">
                <strong>Descrição:</strong>
              </span>
              <div
                className="task-value font text-2"
                dangerouslySetInnerHTML={{
                  __html:
                    focusedTask.description == undefined
                      ? ""
                      : focusedTask.description.replaceAll("\n", "<br>"),
                }}
              ></div>
            </p>

            {/* Status */}
            <p>
              <span className="font text-3">
                <strong>Status:</strong>
              </span>
              <div className="task-value">
                <span className="font text-2">
                  {
                    focusedTask[
                      "statecode@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </span>
              </div>
            </p>

            {/* Created by */}
            <p>
              <span className="font text-3">
                <strong>Criado por:</strong>
              </span>
              <div className="task-value">
                <span className="font text-2">
                  {
                    focusedTask[
                      "_createdby_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </span>
              </div>
            </p>

            {/* Start */}
            <p>
              <span className="font text-3">
                <strong>Início:</strong>
              </span>
              <div className="task-value">
                <span className="font text-2">
                  {formatToClientTimezone(focusedTask["scheduledstart"])}
                </span>
              </div>
            </p>

            {/* End */}
            <p>
              <span className="font text-3">
                <strong>Fim:</strong>
              </span>
              <div className="task-value">
                <span className="font text-2">
                  {formatToClientTimezone(focusedTask["scheduledend"])}
                </span>
              </div>
            </p>

            {/* Duration */}
            <p>
              <span className="font text-3">
                <strong>Duração (HH:MM):</strong>
              </span>
              <div className="task-value">
                <span className="font text-2">
                  {focusedTask == undefined
                    ? ""
                    : floatToTimeString(
                        focusedTask[
                          "scheduleddurationminutes@OData.Community.Display.V1.FormattedValue"
                        ] == undefined
                          ? focusedTask[
                              "scheduleddurationminutes@OData.Community.Display.V1.FormattedValue"
                            ]
                          : focusedTask[
                              "scheduleddurationminutes@OData.Community.Display.V1.FormattedValue"
                            ]
                              .replaceAll(".", "")
                              .replaceAll(",", "") / 60
                      )}
                </span>
              </div>
            </p>
          </form>

          <div className="aside-img-div">
            <img
              src="/assets/icons/close.svg"
              alt=""
              className="top-form-icon icon"
              onClick={handleCloseTaskModal}
            />
            <img src="/assets/images/logo.png" className="bottom-form-logo" />
          </div>
        </Box>
      </Modal>
      <table>
        <thead>
          <tr>
            <th>Assunto</th>
            <th>Descrição</th>
            <th>Status</th>
            <th>Criada por</th>
            <th>Início</th>
            <th>Fim</th>
            <th>Duração (HH:MM)</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item) => (
              <tr key={item.id}>
                <td>
                  <div
                    className="action"
                    id="addContractBtn"
                    onClick={() => handleOpenTaskModal(item)}
                  >
                    <span className="font text-1">{item["subject"]}</span>
                  </div>
                </td>
                <td>
                  <div
                    className="action"
                    id="addContractBtn"
                    onClick={() => handleOpenTaskModal(item)}
                  >
                    <span className="font text-1">{item["description"]}</span>
                  </div>
                </td>
                <td>
                  {item["statecode@OData.Community.Display.V1.FormattedValue"]}
                </td>
                <td>
                  {
                    item[
                      "_createdby_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </td>
                <td>{formatToClientTimezone(item["scheduledstart"])}</td>
                <td>{formatToClientTimezone(item["scheduledend"])}</td>
                <td>
                  {floatToTimeString(
                    item[
                      "scheduleddurationminutes@OData.Community.Display.V1.FormattedValue"
                    ]
                      .replaceAll(".", "")
                      .replaceAll(",", "") / 60
                  )}
                </td>
              </tr>
            ))
          ) : error == null ? (
            <tr>
              <td>Carregando...</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          ) : error == "No tasks" ? (
            <tr>
              <td>Não há atividades cadastradas</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          ) : (
            <tr>
              <td>Erro ao carregar as atividades</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  )
}

export default TasksTable
